"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleCaller__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "address",
    name: "target",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "callFunction",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "payable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class SimpleCaller__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.SimpleCaller__factory = SimpleCaller__factory;
_defineProperty(SimpleCaller__factory, "bytecode", _bytecode);
_defineProperty(SimpleCaller__factory, "abi", _abi);